<template>
    <section class="content">
    <div class="flex justify-content-center">
    <div class="overlay-wrapper">
        <div class="w-100 card">
        <div class="overlay" v-if="loadingContent"><h1 style="font-size:40px;">Sedang diproses <i class="fas fa-sync-alt fa-spin"></i></h1></div>
        <div class="card-body">
            <div v-if="infoDownload" class="form-control bos-alert-primary lh-1 d-flex align-items-center h-100" style="margin-bottom: 15px;">
                <div class="row">
                    <div class="col-auto d-flex align-items-center">
                        <i class="fi fi-rr-info d-flex align-items-center"></i>
                    </div>
                    <div class="col d-flex align-items-center">
                        <div class="text-md">
                            Semua file yang Anda unduh akan tersimpan dan dapat dilihat di <a href="/data-center" class="text-info" style="text-decoration: underline;">menu data center</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
            <div class="col-xl-12 d-flex justify-content-end mb-2">
                <div class="row form-horizontal justify-content-end">
                    <div class="col-auto col-xs-4">
                    <h4>Per Tanggal</h4>
                    </div>
                    <div class="col-md-4 col-xs-4">
                    <div class="input-group mb-3">
                        <input type="text" ref="daterange" class="form-control" style="border-right: 0"/>
                        <div class="input-group-append">
                        <div
                            class="input-group-text"
                            style="background-color: #fff">
                            <span><span class="fa fa-calendar"></span></span>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div class="col-auto col-xs-4"></div>
                    <div class="col-auto col-xs-4">
                        <div class="btn-group" ref="toolbar">
                        <button type="button" data-action="read" class="btn btn-default" v-on:click="showTable">
                            <i class="fa fa-sync-alt"></i> Show Table
                        </button>
                        <button type="button" data-action="export-xlsx" class="btn btn-default" :disabled="loading" v-on:click="downloadXlsx"><i class="fa fa-download"></i> <span class="d-none d-md-inline-block">Download</span></button>
                        <router-link :to="{ path: '/report/hutang/kurir/upload' }" class="btn btn-default"> <i class="fa fa-upload"></i> <span class="d-none d-md-inline-block">Upload</span> </router-link>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="mb-2"></div>
            <div class="table-responsive" :hidden="hideTable">
                <table style="width:100%" class="table table-hover" ref="tblhutang">
                <thead>
                    <tr>
                    <th>TANGGAL</th>
                    <th>NO. AKUN</th>
                    <th>NAMA AKUN</th>
                    <th>KURIR ID</th>
                    <th>KURIR</th>
                    <th>NO. JURNAL</th>
                    <th>REFERENSI</th>
                    <th>DEBIT</th>
                    <th>KREDIT</th>
                    <th>SALDO</th>
                    </tr>
                </thead>
                <tbody @click="handleClick"></tbody>
                <tfoot>
                <tr>
                <th colspan="8"></th>
                <th></th>
                <th></th>
                </tr>
                </tfoot>
                </table>
            </div>
        </div>
        </div>
    </div>
    </div>
    </section>
</template>
<script>
import { authFetch, createTable, formatCurrency } from "@/libs/hxcore";
import Swal from "sweetalert2";
import $ from "jquery";
import Daterangepicker from "daterangepicker";
import moment from "moment";
import "daterangepicker/daterangepicker.css";

export default {
    name: "HutangUsaha",
    data() {
        return {
            dt1: "",
            dt2: "",
            dateStart: "",
            dateEnd: "",
            errors: [],
            method: "",
            jurnal: {
                coa_id: '',
                coa_no: '',
                coa_name: '',
            },
            roles: "",
            role_id: "",
            coa_id: "",
            filter: {},
            loadingContent: false,
            loading: false,
            hideTable: true,
            infoDownload: false
        };
    },
    created: function () {
        this.roles = this.$route.meta.roles;
        console.log("load initial data", this.$route);
        this.dateStart = moment().format("YYYY-MM-DD");
        this.filter.dt1 = this.dateStart;
    },
    methods: {
        onPeriode() {
            if (this.tableHutang) {
                this.tableHutang.api().ajax.reload();
            } else {
                // this.showTable();
            }
        },
        // downloadXlsx: function (e) {
        //     const self = this;
        //     self.loading = true;
        //     self.loadingContent = true;
            
        //     var filter = JSON.parse(JSON.stringify(self.filter));
        //         filter.q = this.tableHutang ? $("input[name=q]").val() : '';
        //         filter.category = this.tableHutang ? $("select[name=category]").val() : 0;

        //     var data = Object.keys(filter)
        //     .map((key) =>
        //         encodeURIComponent(key) + "=" + encodeURIComponent(filter[key])
        //     ).join("&");

        //     authFetch("/report/hutang/excell", {
        //         method: "POST",
        //         body: data,
        //     })
        //     .then((response) => {
        //         if (response.status === 201) {
        //         } else if (response.status === 400) {
        //         } else if (response.status === 500){
        //             Swal.fire("Timeout!", ``, "error");
        //             this.loading = false;
        //             this.loadingContent = false;
        //             return false;
        //         }

        //         return response.blob();
        //     })
        //     .then((blob) => {
        //     setTimeout(() => {
        //         self.loading = false;
        //     }, 1000);
        //     self.loadingContent = false;
        //     var url = window.URL.createObjectURL(blob);
        //     var a = document.createElement("a");
        //     a.href = url;
        //     a.download = "data.xlsx";
        //     document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        //     a.click();
        //     a.remove(); //afterwards we remove the element again
        //     });
        // },
        downloadXlsx: function (e) {
            const self = this;
            self.loading = true;
            self.loadingContent = true;
            self.infoDownload = false;

            var table = $('#tblhutang').DataTable();
            var length = table.page?.info()?.recordsTotal;

			if (length > 20000) {
				Swal.fire("Proses gagal", `Maksimal data sebanyak kurang lebih 20.000 data.`, "error");
                self.loading = false;
				return false;
			}
            
            var filter = JSON.parse(JSON.stringify(self.filter));
                filter.q = this.tableHutang ? $("input[name=q]").val() : '';
                filter.category = this.tableHutang ? $("select[name=category]").val() : 0;

            var data = {
                "module_code": 'hutang_usaha_kurir',
                "filter": filter,
                "title": 'hutang usaha kurir',
                "note": JSON.stringify(filter),
            };

            authFetch("/accounting/jurnal/request_download", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
            .then((res) => {
                setTimeout(() => {
                    self.loading = false;
                }, 1000);
                self.loadingContent = false;
                if (res){
                    self.infoDownload = true;
                }
            });
        },
        handleClick(e) {
            const er = this.$refs;
            if (e.target.matches(".link-role")) {
            }
        },
        showTable: function () {
            if (this.tableHutang) {
                this.tableHutang.api().ajax.reload();
            } else {
                this.hideTable = false;
                const e = this.$refs;
                var self = this;
                this.tableHutang = createTable(e.tblhutang, {
                    title: "",
                    ajax: "/report/hutang",
                    roles: this.$route.params.roles,
                    toolbarEl: e.toolbar,
                    selectedRowClass: "",
                    serverSide: true,
                    frame: false,
                    processing: true,
                    sort: false,
                    language: {
                        processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'},
                    lengthMenu: [[10, 25, 50, 100, 1000, 10000, -1], [ 10, 25, 50, 100, 1000, 10000, 'Semua' ]],
                    displayLength: 10,
                    lengthChange: true,
                    paramData: function (d) {
                        var filter = JSON.parse(JSON.stringify(self.filter));
                        for (const key in filter) {
                            d[key] = filter[key] === false ? 0: filter[key];
                        }
                    },
                    columns: [
                        { data: "journal_date", render: function (data, type, row, meta) {
                            return moment(data).format("DD/MM/YYYY");
                        }, },
                        { data: "coa_no" },
                        { data: "coa_name" },
                        { data: "code" },
                        { data: "name" },
                        { data: "journal_no" },
                        { data: "referensi" },
                        { 
                        data: "sumdebit", 
                        class:'text-right',
                        render: function(data, type, row, meta) {
                            return formatCurrency(data);
                        }
                        },
                        { 
                        data: "sumcredit", 
                        class:'text-right',
                        render: function(data, type, row, meta) {
                            return formatCurrency(data);
                        }
                        },
                        { 
                        data: "sumtotal", 
                        class:'text-right',
                        render: function(data, type, row, meta) {
                            return formatCurrency(data);
                        }
                        },
                    ],
                    filterBy: [5,6],
                    rowCallback: function (row, data) {},
                    footerCallback:function ( row, data, start, end, display ){
                    var api = this.api(), data;
                        // Total over this page
                        var totaldebit;
                        totaldebit = 
                            api
                            .column(7)
                            .data()
                            .reduce( function (a, b) {
                                var x = parseFloat( a ) || 0;
                                var y = parseFloat( b ) || 0;
                                return x + y;
                            }, 0);

                        var totalcredit;
                        totalcredit = api
                            .column(8)
                            .data()
                            .reduce( function (a, b) {
                                var x = parseFloat( a ) || 0;
                                var y = parseFloat( b ) || 0;
                                return x + y;
                            }, 0 );

                        var totalsaldo;
                        totalsaldo = api
                            .column(9)
                            .data()
                            .reduce( function (a, b) {
                                var x = parseFloat( a ) || 0;
                                var y = parseFloat( b ) || 0;
                                return x + y;
                            }, 0 );

                        // Update footer
                            $( api.column(7).footer() ).html(
                                'Rp '+ formatCurrency(totaldebit)
                            );
                            $( api.column(8).footer() ).html(
                                'Rp '+ formatCurrency(totalcredit)
                            );
                            $( api.column(9).footer() ).html(
                                'Rp '+ formatCurrency(totalsaldo)
                            );
                    }
                });
            }
        }
    },
    mounted() {
    const e = this.$refs;
    const self = this;
    new Daterangepicker(this.$refs.daterange, {
        startDate: moment(),
        endDate: moment(),
        singleDatePicker: true,
        showDropdowns: true,
        locale: {
            format: 'DD/MM/YYYY'
        }
        }, function (d1, d2) {
        self.dateStart = d1.format("YYYY-MM-DD");
        self.dateEnd = d2.format("YYYY-MM-DD");
        self.filter.dt1 = self.dateStart;
        self.onPeriode();
        });
    $('.loading-overlay').removeClass('show');
    },
}
</script>